import React from 'react'
import { FormFieldInterface } from 'src/shared/types/entities/form-interface'
import { BasePublisherBaseField } from '../../base-publisher-field/base-publisher-base-field'
import { useFormField } from '../hooks/use-form-field'

interface FormEmailFieldSubentityProps {
  fieldSubentity: FormFieldInterface
}

export const FormEmailFieldSubentity = ({
  fieldSubentity,
}: FormEmailFieldSubentityProps) => {
  const { value, onChange, errors } = useFormField({ fieldSubentity })
  return (
    <BasePublisherBaseField
      type="email"
      entity={fieldSubentity}
      value={value}
      onChange={onChange}
      errors={errors}
    />
  )
}
